module.exports = __webpack_public_path__ + "static/media/assessment-footer-bg.8a1bf70c.png";